import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import Navbar from './components/Navbar';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Solutions from './pages/Solutions';
import CaseStudies from './pages/CaseStudies';
import About from './pages/About';
import Contact from './pages/Contact';

// Service Pages
import AEMDevelopment from './pages/AEMDevelopment';
import ITHardwareSolutions from './pages/ITHardwareSolutions';

// Lead Generation Pages
import RequestHardwareQuote from './pages/RequestHardwareQuote';
import FreeAEMConsultation from './pages/FreeAEMConsultation';

// Blog Pages
import BlogAEM65VsAEMCloud from './pages/BlogAEM65VsAEMCloud';
import BlogHardwareProcurement from './pages/BlogHardwareProcurement';
import BlogAEMDispatcherCaching from './pages/BlogAEMDispatcherCaching';
import BlogCloudMigration from './pages/BlogCloudMigration';
import BlogDataCenterPlanning from './pages/BlogDataCenterPlanning';

function App() {
  const showCaseStudies = false;

  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <div className="flex flex-col min-h-screen">
          <Navbar />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/solutions" element={<Solutions />} />
              <Route
                path="/case-studies"
                element={showCaseStudies ? <CaseStudies /> : <Navigate to="/" replace />}
              />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              
              {/* Service Pages */}
              <Route path="/digital-experience-platform-solutions" element={<AEMDevelopment />} />
              <Route path="/it-hardware-solutions" element={<ITHardwareSolutions />} />
              
              {/* Lead Generation Pages */}
              <Route path="/request-hardware-quote" element={<RequestHardwareQuote />} />
              <Route path="/free-aem-consultation" element={<FreeAEMConsultation />} />
              
              {/* Blog Pages */}
              <Route path="/blog/aem-6-5-vs-aem-cloud" element={<BlogAEM65VsAEMCloud />} />
              <Route path="/blog/how-to-plan-enterprise-hardware-procurement" element={<BlogHardwareProcurement />} />
              <Route path="/blog/aem-dispatcher-caching-best-practices" element={<BlogAEMDispatcherCaching />} />
              <Route path="/blog/enterprise-cloud-migration-strategy" element={<BlogCloudMigration />} />
              <Route path="/blog/data-center-hardware-planning-guide" element={<BlogDataCenterPlanning />} />
            </Routes>
          </main>
          <Footer />
          <WhatsAppButton />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
